<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('unsuspend.unsuspend') }}
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div
                v-if="!isLoaded"
                class="row"
            >
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div class="box-body">
                            <img
                                alt="preloader"
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"/>
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="isLoaded">
                <UnsuspendProcesses
                    v-show="isLoaded"
                    :isLoading="isLoading"
                    :isUploading="isUploading"
                    :processes="ususpendProcesses"
                    :uploadingProgressText="uploadingProgressText"
                    :uploadingProgressValue="uploadingProgressValue"
                    @createProcess="createProcess"
                    @confirmProcess="processData = $event"
                    @startProcess="startProcess"
                />
            </div>
        </section>

        <ModalDialog
            id="confirm-modal"
            ref="confirmModal"
            :isLoading="isLoading"
            class="modal-danger"
            size="sm"
            @closed="processData = {}"
            @submit="submitProcess"
        >
            <template #header>
                {{
                    processData.status === PROCESS_STATUS_PROCESSING
                        ? `${$t('cancel')} ${$t('process')}?`
                        : `${$t('delete')} ${$t('process')}?`
                }}
            </template>

            <template #footer="{ close, submit }">
                <button
                    class="btn btn-sm btn-default"
                    data-dismiss="modal"
                    type="button"
                    @click="close"
                >
                    {{ $t('close') }}
                </button>

                <button
                    :disabled="isLoading"
                    class="btn btn-sm btn-danger"
                    @click="submit"
                >
                    <i
                        v-if="isLoading"
                        class="fa fa-refresh fa-spin"
                    />
                    <span>{{ processData.status === PROCESS_STATUS_PROCESSING ? $t('cancel') : $t('delete') }}</span>
                </button>
            </template>
        </ModalDialog>

    </div>
</template>
<script>
import EventBus from '@/event-bus';
import UnsuspendProcesses from "../../../components/additional/unsuspend/UnsuspendProcesses.vue";
import ModalDialog from '@/components/modals/ModalDialog';
import processMixin from '@/mixins/processMixin';

export default {
    name: 'AdditionalUnsuspend',
    components: {
        UnsuspendProcesses,
        ModalDialog,
    },
    mixins: [processMixin],
    data() {
        return {
            isLoading: false,
            isLoaded: false,
            timeout: 0,
            ususpendProcesses: [],
            processData: {},
            fetchProcessCancelToken: null,
            isUploading: false,
            uploadingProgressValue: 0,
            uploadingProgressText: ''
        };
    },
    async created() {
        await this.fetchProvesses();
        this.isLoaded = true;
    },
    methods: {
        async fetchProvesses() {
            this.fetchProcessCancelToken = axios.CancelToken.source();

            try {
                const {
                    data: { processes },
                } = await axios.get('/additional/unsuspend/data', {
                    cancelToken: this.fetchProcessCancelToken.token,
                });

                this.ususpendProcesses = processes.map((process) => {
                    process.isShow = true;
                    return process;
                });

                this.checkProgress();
            } catch (error) {
                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.fetchProcessCancelToken = null;
            }
        },
        async createProcess({ event }) {
            if (this.fetchProcessCancelToken) {
                this.fetchProcessCancelToken.cancel('createProcess: cancel');
            }

            if (event && !event.target.files[0]) {
                return;
            }

            const requestData = new FormData();
            event && requestData.append('file', event.target.files[0]);
            this.isUploading = true;
            this.isLoading = true;

            try {
                const {
                    data: { process },
                } = await axios.post('/additional/unsuspend/data/process', requestData, {
                    onUploadProgress: ({ loaded, total }) => {
                        if (event) {
                            this.uploadingProgressValue = Math.floor((loaded / total) * 100);

                            if (total < 1024) {
                                this.uploadingProgressText = `${loaded} / ${total} Bytes`;
                            } else if (total < 1024 * 1024) {
                                this.uploadingProgressText = `${(loaded / 1024).toFixed(2)} / ${(total / 1024).toFixed(2)} KB`;
                            } else {
                                this.uploadingProgressText = `${(loaded / (1024 * 1024)).toFixed(2)} / ${(
                                    total /
                                    (1024 * 1024)
                                ).toFixed(2)} MB`;
                            }
                        }
                    },
                });

                this.ususpendProcesses.unshift(process);

                setTimeout(() => {
                    this.$set(this.ususpendProcesses, 0, {
                        ...process,
                        isShow: true,
                    });

                    if (event) {
                        setTimeout(() => {
                           this.isUploading = false;

                            setTimeout(() => {
                                this.uploadingProgressValue = 0;
                                this.uploadingProgressText = '';
                            }, 1000);
                        }, 1000);
                    }
                }, 1);

                this.checkProgress();

            } catch (error) {
                this.isUploading = false;
                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoading = false;
                this.isCreating = false;
            }
        },
        checkProgress() {
            const isProgress = !!this.ususpendProcesses.find((process) => {
                return process.status === this.PROCESS_STATUS_PROCESSING;
            });

            clearTimeout(this.timeout);

            if (isProgress) {
                this.timeout = setTimeout(() => {
                    this.fetchProvesses();
                }, 5000);
            }
        },
        async updateProcess(processId, status) {
            this.isLoading = true;

            try {
                const {
                    data: { process },
                } = await axios.put(`/additional/unsuspend/data/process/${processId}`, {
                    status,
                });

                this.ususpendProcesses.forEach((ususpendProcesses) => {
                    if (ususpendProcesses.id === process.id) {
                        ususpendProcesses.status = status;
                    }
                });

                this.checkProgress();
            } catch (error) {
                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoading = false;
            }
        },
        async deleteProcess(processId) {
            this.isLoading = true;

            try {
                await axios.delete(`/additional/unsuspend/data/process/${processId}`);
                this.ususpendProcesses.forEach((process, idx) => {
                    if (process.id === processId) {
                        process.isShow = false;
                        setTimeout(() => {
                            this.ususpendProcesses.splice(idx, 1);
                            this.checkProgress();
                        }, 1000);
                    }
                });

            } catch (error) {
                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoading = false;
            }
        },
        startProcess(processData) {
            if (processData.status !== this.PROCESS_STATUS_CANCELED) return;

            this.updateProcess(processData.id, this.PROCESS_STATUS_PROCESSING);
        },
        async submitProcess() {
            if (this.processData.status === this.PROCESS_STATUS_PROCESSING) {
                await this.updateProcess(this.processData.id, this.PROCESS_STATUS_CANCELED);
            } else {
                await this.deleteProcess(this.processData.id);
            }

            this.$refs.confirmModal.close();
        },
    },
};
</script>
